import React from 'react'
import { Modal, Button } from 'react-bootstrap'
import Input from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'
import { Map } from 'immutable'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class SaveSearchModal extends React.Component {
  static propTypes = {
    open: React.PropTypes.bool,
    title: React.PropTypes.string.isRequired,
    onClose: React.PropTypes.func
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      active: false,
      search: Map({})
    }
  }

  componentWillReceiveProps (props) {
    if (!props.open) return

    this.setState({
      active: true
    })
  }

  showWindow () {
    this.setState({ active: true })
  }

  hideWindow () {
    const { onClose } = this.props

    this.setState({
      active: false,
      search: Map({})
    })

    if (onClose) onClose()
  }

  async saveSearch (evt) {
    evt.preventDefault()

    const { search } = this.state
    const { store } = this.context
    const lastSearch = JSON.parse(store.storage.lastSearch || '{}')

    try {
      await store.post('/searches', {
        desc: search.get('desc'),
        notify: search.get('notify'),
        criteria: lastSearch
      })
      this.hideWindow()
    }
    catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  render() {
    const { title } = this.props
    const ln = createLinkToImmutable(this, 'search')

    return (
      <div style={{ display: 'inline' }}>
        <Modal show={this.state.active} onHide={::this.hideWindow}>
          <Modal.Header closeButton>
            <h4 className="modal-title">{title}</h4>
          </Modal.Header>

          <Modal.Body>
            <p>
              Enter a unique name and click SAVE.
              It can be recalled from the search page to show the most current data available.
            </p>
            <Input
              autoFocus
              type="text"
              valueLink={ln('desc')}
              name="desc" />
            {/* <Input
              type="checkbox"
              label="Email me when new records matching my saved search are added to the system"
              checkedLink={ln('notify')}
              name="notify" /> */}
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="submit"
              bsStyle="success"
              disabled={!ln('desc').value}
              onClick={::this.saveSearch}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

export default SaveSearchModal



// WEBPACK FOOTER //
// ./modules/shared/components/saveSearchModal.js